import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.component.html',
  styleUrls: ['./task-detail.component.scss']
})
export class TaskDetailComponent implements OnInit {

  close:boolean = false;
  SubTask:boolean = false;
  PI:boolean = true;

 

  @Output() closeTaskDetail = new EventEmitter<boolean>()
  @Output() showPI = new EventEmitter<boolean>()


  showIntelligence(message){
    this.showPI.emit(message)
  }

  constructor() { }

  ngOnInit(): void {
  }

  closedetail(message:boolean){
    this.closeTaskDetail.emit(message)
  }

  showSubTask(){
    this.SubTask = !this.SubTask
  }

}
